import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
import { getICSEvent } from "@grandvisionhq/lib-ics";
const ICSButton = ({
  appointmentType,
  className,
  timeSlot,
  store,
  onClick,
  ...rest
}) => {
  const onButtonClick = React.useCallback(() => {
    onClick?.();
    getICSEvent({
      description: appointmentType.description,
      timeSlot,
      name: appointmentType.name,
      location: store,
      id: appointmentType.id
    });
  }, [appointmentType, timeSlot, store, onClick]);
  return /* @__PURE__ */ React.createElement(Button, { ...rest, onClick: onButtonClick, className: classnames("ics-button", className) });
};
export {
  ICSButton as default
};
//# sourceMappingURL=ICSButton.js.map
